import React from "react";
import "./Pricing.css";
import checkMark from "../../assets/check.png";
import { Link } from "react-router-dom";
import ig from "../../assets/footer-social/ig.png";
import linkedin from "../../assets/footer-social/linkedin.png";
import twitter from "../../assets/footer-social/twitter.png";
import seperator from "../../assets/seperator.png";
import locationMarker from "../../assets/footer-social/location.png";
import Carousel from "../Carousel/Carousel";

const Pricing = () => {

  return (
    <>
      <div className="section pricing-hero-section">
        <div className="container-fluid pricing-outer-container">
          <div className="container pricing-inner-container">
            <div className="row justify-content-center gy-5">
              <div className="col-xl-3 col-lg-7 col-md-8 col-sm-12 col-12">
                <div className="pricing-card">
                  <p className="pricing-category">free</p>
                  <p className="pricing-category-description">
                    created for small group
                  </p>
                  <div className="pricing-card-price">
                    <p>
                      <span>$ 0</span>
                      USD/user
                    </p>
                    <p>0RS/user</p>
                  </div>
                  <button>start for free</button>
                  <br />
                  <p className="pricing-category-benefits">
                    almost all benefits of paid versions
                  </p>
                  <p>
                    <span>
                      <img src={checkMark} alt="" />
                      &nbsp;&nbsp;
                      <span className="checkmark-desc">
                        up to 25 concurrent users
                      </span>
                    </span>
                    <br />
                    <span>
                      <img src={checkMark} alt="" />
                      &nbsp;&nbsp;
                      <span className="checkmark-desc">
                        customizable maps
                      </span>
                    </span>
                    <br />
                    <span>
                      <img src={checkMark} alt="" />
                      &nbsp;&nbsp;
                      <span className="checkmark-desc">
                        unlimited interactive objects
                      </span>
                    </span>
                  </p>
                </div>
              </div>
              <div className="col-xl-3 col-lg-7 col-md-8 col-sm-12 col-12">
                <div className="pricing-card">
                  <p className="pricing-category">per day</p>
                  <p className="pricing-category-description">
                    ideal for conferences and offsites
                  </p>
                  <div className="pricing-card-price">
                    <p>
                      <span>$ 2</span>
                      USD/user
                    </p>
                    <p>150INR/user</p>
                  </div>
                  <button>proceed</button>
                  <br />
                  <p className="pricing-category-benefits">
                    all the benefits of free, plus
                  </p>
                  <p>
                    <span>
                      <img src={checkMark} alt="" />
                      &nbsp;&nbsp;
                      <span className="checkmark-desc">
                        up to 500 concurrent users
                      </span>
                    </span>
                    <br />
                    <span>
                      <img src={checkMark} alt="" />
                      &nbsp;&nbsp;
                      <span className="checkmark-desc">
                        email guest list
                      </span>
                    </span>
                    <br />
                    <span>
                      <img src={checkMark} alt="" />
                      &nbsp;&nbsp;
                      <span className="checkmark-desc">
                        restricted access
                      </span>
                    </span>
                  </p>
                </div>
              </div>
              <div className="col-xl-3 col-lg-7 col-md-8 col-sm-12 col-12">
                <div className="pricing-card">
                  <p className="pricing-category">monthly</p>
                  <p className="pricing-category-description">
                    built for remote teams big & small
                  </p>
                  <div className="pricing-card-price">
                    <p>
                      <span>$ 5</span>
                      USD/user
                    </p>
                    <p>225INR/user</p>
                  </div>
                  <button>proceed</button>
                  <br />
                  <p className="pricing-category-benefits">
                    almost all benefits of paid versions
                  </p>
                  <p>
                    <span>
                      <img src={checkMark} alt="" />
                      &nbsp;&nbsp;
                      <span className="checkmark-desc">
                        up to 25 concurrent users
                      </span>
                    </span>
                    <br />
                    <span>
                      <img src={checkMark} alt="" />
                      &nbsp;&nbsp;
                      <span className="checkmark-desc">
                        customizable maps
                      </span>
                    </span>
                    <br />
                    <span>
                      <img src={checkMark} alt="" />
                      &nbsp;&nbsp;
                      <span className="checkmark-desc">
                        unlimited interactive objects
                      </span>
                    </span>
                  </p>
                </div>
              </div>
              <div className="col-xl-3 col-lg-7 col-md-8 col-sm-12 col-12">
                <div className="pricing-card">
                  <p className="pricing-category">enterprise</p>
                  <p className="pricing-category-description">
                    built for power users of all kinds
                  </p>
                  <div className="pricing-card-price">
                    <p
                      style={{
                        fontWeight: 500,
                      }}
                    >
                      Customised Pricing
                    </p>
                  </div>
                  <button>get in touch</button>
                  <br />
                  <p className="pricing-category-benefits">
                    almost all benefits of paid versions
                  </p>
                  <p>
                    <span>
                      <img src={checkMark} alt="" />
                      &nbsp;&nbsp;
                      <span className="checkmark-desc">
                        up to 25 concurrent users
                      </span>
                    </span>
                    <br />
                    <span>
                      <img src={checkMark} alt="" />
                      &nbsp;&nbsp;
                      <span className="checkmark-desc">
                        customizable maps
                      </span>
                    </span>
                    <br />
                    <span>
                      <img src={checkMark} alt="" />
                      &nbsp;&nbsp;
                      <span className="checkmark-desc">
                        unlimited interactive objects
                      </span>
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Carousel mode={'light'}/>
      <div className="container-fluid revirtclubfooter social-footer">
        <div className="container">
          <div className="row justify-content-center gy-3" style={{
            margin: 0
          }}>
            <div
              className="col-xl-2 col-lg-2 col-md-3 col-sm-12 col-12 footer-pp-col"
              style={{
                display: 'flex',
                justifyContent: 'space-evenly',
                alignItems: 'center',
                margin: 0,
                padding: 0
              }}
              >
              <div className="footer-policy-links">
                <Link to='/privacypolicy' className="pp-link-footer">
                  <p className="pp-footer-name">privacy policy</p>
                </Link>
                <p className="pp-footer-name">terms of use</p>
              </div>
              {window.innerWidth > 767 ? (
                <div>
                  <img src={seperator} alt="" className="seperator" />
                </div>
              ) : (
                <></>
              )}
            </div>
            <div
              className="social-footer-icons-container col-xl-1 col-lg-2 col-md-3 col-sm-3 col-5"
            >
              <img src={ig} alt="" />
              <div className="icons-container-1">
                <img src={twitter} alt="" />
              </div>
              <div className="icons-container-2">
                <img src={linkedin} alt="" />
              </div>
            </div>
            <div
              className="col-xl-2 col-lg-2 col-md-3 col-sm-12 col-12 contact-footer-col"
            >
              {window.innerWidth > 767 ? (
                <div>
                  <img src={seperator} alt="" className="seperator" />
                </div>
              ) : (
                <></>
              )}
              <div>
                <p className="contact-footer">contact</p>
                <p className="email-footer">office@revirt.space</p>
              </div>
            </div>
            <div
              className="col-xl-6 col-lg-6 col-md-3 col-sm-12 col-12 locationcol col-12">
              <img src={locationMarker} alt="" className="locationIcon" />
              &nbsp;&nbsp;
              <p>from our offices in the revirt metaverse</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Pricing;
